import React from 'react';

import TasksListAsOwner from './TasksListAsOwnerContent';
import RightSidebarSearchForm from './RightSidebarMyTasks';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import GroupsSearchCollector from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchCollector';
import groupsSearchItem from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(TasksListAsOwner);
const Content = ColumnsContent(
  GroupsSearchCollector(props => (
    <GroupsSearchItem
      {...props}
      groupName="tasksListAsOwner"
      listReduceName="tasksModule.lists.tasksListAsOwner"
    />
  )),
  () => (
    <RightSidebarSearchForm
      listReduceName="tasksModule.lists.tasksListAsOwner"
      isHideTaskOwnersInputs
    />
  )
);

export default props => <Content {...props} />;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/_myTasksCommon/index.js